import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-[70vh] grid place-items-center px-6" data-testid="page-not-found">
      <div className="text-center">
        <div className="font-mono text-xs uppercase tracking-widest text-[#ff2a2a]">404 · Off the map</div>
        <h1 className="mt-3 font-display text-6xl uppercase tracking-tight">Wrong exit.</h1>
        <p className="mt-3 text-zinc-400">That page doesn&rsquo;t exist. Let&rsquo;s get you back on the highway.</p>
        <Link to="/" className="mt-6 inline-block bg-[#ff2a2a] hover:bg-[#e01f1f] text-white text-sm font-semibold px-6 py-3 transition-colors" data-testid="notfound-home">
          Back to Home
        </Link>
      </div>
    </div>
  );
}
